import { useCallback, useEffect, useRef } from 'react';

/**
 * ADM-15-AC2。最後に始めた要求の応答だけを画面に反映する。
 *
 * 検索・ページ・絞り込みを素早く変えると、遅れて届いた古い応答が新しい結果を上書きしていた。
 * 要求の前に beginRequest() を呼び、返った関数で「まだ最新か」を確かめてから setState する。
 * 画面を離れた（unmount した）後の応答も捨てる。
 *
 *   const beginRequest = useLatestRequest();
 *   const isCurrent = beginRequest();
 *   const response = await axiosInstance.get(url);
 *   if (!isCurrent()) return;
 */
export function useLatestRequest(): () => () => boolean {
  const latest = useRef(0);

  useEffect(
    () => () => {
      latest.current += 1;
    },
    []
  );

  return useCallback(() => {
    const request = ++latest.current;
    return () => request === latest.current;
  }, []);
}
